module.exports = __webpack_public_path__ + "static/media/rtlupldrtemplate.0c8aed9d.csv";